import { useTranslation } from 'react-i18next';
import { BusinessRegistry } from '@paladin-monorepo/common';

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
} from '@/components/ui/select';
import { cn } from '@/lib/utils';

const OPTIONS: { value: BusinessRegistry; flag: string }[] = [
  { value: BusinessRegistry.CZ, flag: '🇨🇿' },
  { value: BusinessRegistry.SK, flag: '🇸🇰' },
  { value: BusinessRegistry.DE, flag: '🇩🇪' },
  { value: BusinessRegistry.PL, flag: '🇵🇱' },
  { value: BusinessRegistry.OTHER, flag: '🌐' },
];

interface RegistryCountrySelectProps {
  value: BusinessRegistry;
  onChange: (value: BusinessRegistry) => void;
  disabled?: boolean;
  className?: string;
}

/** Tiny country/registry picker rendered as an appendix of the company field. */
export function RegistryCountrySelect({
  value,
  onChange,
  disabled,
  className,
}: RegistryCountrySelectProps) {
  const { t } = useTranslation();
  const selected = OPTIONS.find((option) => option.value === value) ?? OPTIONS[0];

  return (
    <Select
      value={value}
      onValueChange={(next) => onChange(next as BusinessRegistry)}
      disabled={disabled}
    >
      <SelectTrigger
        size="sm"
        aria-label={t('signup.form.company.registry.label')}
        className={cn('border-0 bg-transparent px-1.5 shadow-none dark:bg-transparent', className)}
      >
        <span aria-hidden>{selected.flag}</span>
      </SelectTrigger>
      <SelectContent align="end">
        {OPTIONS.map((option) => (
          <SelectItem key={option.value} value={option.value}>
            <span aria-hidden>{option.flag}</span>
            <span>{t(`signup.form.company.registry.${option.value}`)}</span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
